<template>

    <Forms ref="frmComission"
            :title="'Buscar Comissão'"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            v-on:Clear="Clear"
            v-on:Search="Search"
            v-on:Load ="onLoad"
          >
        <div>
          <div id="form-search">
              <label class="labelseach">Corretor</label>
              <autocomplete-z ref="CommissionTypeahead"
                          placeholder="Digite um corretor"
                          iconClass="fas fa-user"
                          :serializer="(corretor) => corretor.nome"
                          :debounceLength="2"
                          :formField="SearchItems.corretor"
                          v-on:search="onSearchComission"
                          v-on:changeCode="onChangeCodeComission"
                          :ShowCode="false"
                           />

              <label class="labelseach mt-3">Cliente</label>
              <autocomplete-z ref="CommissionClientTypeahead"
                          placeholder="Digite um cliente"
                          iconClass="fas fa-user"
                          :serializer="(cliente) => cliente.nome"
                          :debounceLength="2"
                          :formField="SearchItems.cliente"
                          v-on:search="onSearchComissionClient"
                          v-on:changeCode="onChangeCodeComissionClient"
                          :ShowCode="false"
                           />

              <label  class="labelseach mt-3">Empreendimento</label>
              <select v-model ="SearchItems.empreendimentoId" class="form-control" id="exampleFormControlSelect2">
                <option disabled :value= "''" >Selecione um empreendimento</option>
                <option  v-for="data in consultacomissao" v-bind:key="data.empreendimento.id" :value="data.empreendimento.id">{{data.empreendimento.nome}}</option>
              </select>
              <label class="labelseach mt-3">Status</label>
              <select name="status" class="form-control" v-model="SearchItems.statusSelecionado" id="exampleFormControlSelect2">
                <option v-for="status in comissaostatus" :key="status.value" :value="status.value">{{status.text}}</option>
              </select>
              <label class="labelseach mt-3" for="txtInsured">Data Da Venda</label>
              <label class="labelseach mt-3" > Desde </label>
              <div class="d-flex align-items-end">
                <b-form-datepicker
                v-model ="SearchItems.DataInicio"
                  placeholder="__/__/__"
                  locale="pt-BR"
                  today-button
                  label-today-button="Hoje"
                  reset-button
                  label-reset-button="Limpar"
                  close-button
                  label-close-button="Fechar"
                  :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
              </div>

              <label class="labelseach mt-3" > Até </label>
              <div class="margem d-flex align-items-end">
                  <b-form-datepicker
                  v-model ="SearchItems.DataFinal"
                  today-button
                  label-today-button="Hoje"
                  reset-button
                  label-reset-button="Limpar"
                  close-button
                  label-close-button="Fechar"
                  placeholder="__/__/__"
                  locale="pt-BR"
                  :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
              </div>
          </div>
        </div>
    </Forms>

</template>

<script>
import FormSearchComission from './FormSearchComission'
export default FormSearchComission
</script>

<style scoped>
.margem{
  margin-bottom: 7%;
}

#form-search{
  display: flex;
  flex-direction: column;
  align-content: center;
}

.labelseach{
  font-weight: bold;
  color: #666666;
  font-size: 14px;
  margin-bottom: 5px;
  padding-bottom: 0px;
  font-family: 'Segoe UI';
}

#app.zopone .text-third{

  font-size: 16px;
  font-weight: normal;

}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/commissioncheck/components/FormSearchComission/FormSearchComission.vue